// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Styles from "../../Styles.bs.js";
import * as RimbleUi from "rimble-ui";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";

var featuredMediaContent = [
  {
    imagePath: "/img/featured-media/hackernoon.svg",
    link: "https://hackernoon.com/connecting-the-dots-between-blockchain-and-sustainability-6ncc3234"
  },
  {
    imagePath: "/img/featured-media/ubisoft.svg",
    link: "https://news.ubisoft.com/en-us/article/0fbsdbsFNL5T0vTDkx924/how-the-ubisoft-entrepreneurs-lab-empowers-communities"
  },
  {
    imagePath: "/img/featured-media/decrypt.svg",
    link: "https://decrypt.co/10561/ubisoft-picks-eight-blockchain-startups-for-entrepreneur-lab"
  },
  {
    imagePath: "/img/featured-media/ventureburn.svg",
    link: "https://ventureburn.com/2020/01/sa-crypto-startup-wildcards-cv-vc-investment/"
  },
  {
    imagePath: "/img/featured-media/cointelegraph.svg",
    link: "https://cointelegraph.com/news/wildcards-purports-to-save-endangered-species-with-technical-first-for-ethereum"
  },
  {
    imagePath: "/img/featured-media/coindesk.svg",
    link: "https://www.coindesk.com/nfts-boring-make-fun"
  }
];

var featuredItemImgStyle = Curry._1(Css.style, {
      hd: Css.width({
            NAME: "percent",
            VAL: 80
          }),
      tl: {
        hd: Css.minWidth({
              NAME: "px",
              VAL: 30
            }),
        tl: {
          hd: Css.padding({
                NAME: "rem",
                VAL: 1
              }),
          tl: /* [] */0
        }
      }
    });

var featuredContainerStyles = Curry._1(Css.style, {
      hd: Css.maxWidth(Css.px(1200)),
      tl: {
        hd: Css.margin(Css.auto),
        tl: /* [] */0
      }
    });

function FeaturedIn(Props) {
  return React.createElement(RimbleUi.Box, {
              children: null,
              className: Styles.horizantalBlueTile
            }, React.createElement("p", {
                  className: Styles.explainerLargeText
                }, "Featured in "), React.createElement(RimbleUi.Flex, {
                  children: Belt_Array.mapWithIndex(featuredMediaContent, (function (index, x) {
                          return React.createElement(RimbleUi.Box, {
                                      p: 2,
                                      mb: 2,
                                      children: React.createElement("a", {
                                            href: x.link
                                          }, React.createElement("img", {
                                                className: featuredItemImgStyle,
                                                src: x.imagePath
                                              })),
                                      width: [
                                        0.5,
                                        0.5,
                                        0.16
                                      ],
                                      key: String(index)
                                    });
                        })),
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "center",
                  className: featuredContainerStyles
                }));
}

var make = FeaturedIn;

export {
  featuredMediaContent ,
  featuredItemImgStyle ,
  featuredContainerStyles ,
  make ,
  
}
/* featuredItemImgStyle Not a pure module */
